import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import { SET_STATUS, BulkIdRegisterModalStatus } from './constants';

export const initialState = Map({
  status: BulkIdRegisterModalStatus.INITIAL,
});

const spec = {
  [SET_STATUS]: (state, action) => state.set('status', action.payload),
};

export default createReducerBySpec(spec, initialState);
